import React from 'react';

import { Collapse } from 'antd';

const RobustStatistics = (props) => {
    const { Panel } = Collapse;

    let statisticsData = props.getAnalysisRes.robust_statistics.stats;
    let statsRows = [];
    let robustStatisticsData = props.getAnalysisRes.robust_statistics.robust_stats;
    let robustStatsRows = [];

    for (let i = 0; i < Object.keys(statisticsData).length; i++) {
        statsRows.push(Object.values(statisticsData)[i]);
    }

    let statisticsMap = statsRows.map((item) => {
        return (
            <tr>
                <td className="title">{item.display_name}</td>
                <td className="value">{item.value}</td>
            </tr>
        );
    });

    let statisticsTable = (
        <>
            <div key="12345">

                <div className="statistics-row-box">
                    <div className="table-box-fullproject-view">

                        <table className="table-table">
                            <tbody>{statisticsMap}</tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );

    for (let i = 0; i < Object.keys(robustStatisticsData).length; i++) {
        // robustStatsRows.push(Object.values(robustStatisticsData)[i].display_name, Object.values(robustStatisticsData)[i].location, Object.values(robustStatisticsData)[i].scale);
        robustStatsRows.push(<tr key={i}>
            <td style={{fontWeight: 700,
                fontSize: '12px',
                lineHeight: '18px'}} 
            >
                {Object.values(robustStatisticsData)[i].display_name}</td>
            <td>{Object.values(robustStatisticsData)[i].location}</td>
            <td >{Object.values(robustStatisticsData)[i].scale}</td>
        </tr>)
    }



    console.log(`robustStatsRows: ${robustStatsRows}`)

    // let robustStatisticsMap = robustStatsRows.map((item) => {
    //     return (
    //         <tr>
                
    //         </tr>
    //     );
    // });

    let robustStatisticsTable = (
        <>
            <div style={{marginTop:'50px'}}>

                <div className="statistics-row-box">
                    <div className="table-box-fullproject-view">

                        <table className="table-regression">
                            {/* <tbody>{robustStatisticsMap}</tbody> */}
                            
                            <tbody>
                                <tr>
                                    <td></td>
                                    <td className='ff-rb'>Location</td>
                                    <td className='ff-rb'>Scale</td>
                                </tr>
                                {robustStatsRows}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );



    let fullStats = (
        <div ref={props.forwardedRef}>{statisticsTable} {robustStatisticsTable}</div>
    );

    return (
        <>
            <Collapse bordered={false} defaultActiveKey={[1]}>
                <Panel key={1} header={`Robust Statistics ${props.getAnalysisRes.filter_by_variable == null ? '': `[${props.getAnalysisRes.filter_by_variable}]`}`}>
                    {fullStats}
                </Panel>
            </Collapse>
        </>
    );
};

export default React.memo(RobustStatistics);
